import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/community/leaderboard')({
  component: () => <PageStub title="Leaderboard" description="Top performers and rankings" />,
});
